module.exports = __webpack_public_path__ + "img/08.6c79efa5.png";